import React from "react";
import { useDispatch } from "react-redux";
import Table from './ReportsTable';
import Pagination from './ReportsPagination';
import NoReportFound from '@/shared/components/NoReportFound';
import { useCurrentTool } from "@/shared/hooks/useCurrentTool"
import { useReportsContext } from '@/features/reports/ReportsContext';
import { setSelectedReport } from '@/store/slices/ReportsSlice'
import { pageSize } from '@/shared/config/constants';

function Content() {
  const dispatch = useDispatch();
  const { currentToolFields, generation_name } = useCurrentTool();
  
  const {
    selectedTabRef,
    handleRetry,
    setDrawerOpen,
    page,
    setPage,
    setShowNotification,
    reports,
  } = useReportsContext();

  const selectedTabReports = reports[selectedTabRef.current];

  const handleReportDrawer = (reportId) => {
    const report = selectedTabReports?.reports?.find(
      (report) => report.id === reportId
    );

    if (!report || !report.report_fetched) {
      console.log("Report not found");
      return;
    }

    // Check if the status is "processing"
    if (report?.status === "processing") {
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
      return;
    }

    let updatedReport = { ...report };
    // If the report exists and contains placeholders, replace them
    if (report && report.report) {
      currentToolFields.forEach((field) => {
        const placeholder = `placeholder_${field.name}`;
        updatedReport.report = updatedReport.report?.replace(
          new RegExp(placeholder, "g"),
          (report.fields && report.fields[field.name]) || report[field.name] || ""
        );
      });
    }

    dispatch(setSelectedReport(updatedReport));
    setDrawerOpen(true);
  };

  if (selectedTabReports?.reports?.length > 0 && generation_name) {
    return (
      <div className="w-full">
        <Table
          selectedTabReports={selectedTabReports}
          hideTypeColumn={[]}
          handleReportDrawer={handleReportDrawer}
          handleRetry={handleRetry}
        />

        <Pagination
          selectedTabReports={selectedTabReports}
          pageSize={pageSize}
          page={page}
          setPage={setPage}
        />
      </div>
    );
  } else {
    return (
      <div className="my-12">
        <NoReportFound />
      </div>
    );
  }
}

export default Content;
